define(function(require) {
    'use strict';

    var i18n = require('i18n');
    const validationUtil = require('modules/user/spanish-regulations/user.validation.util');
    const { checkControlLetter, checkDNI, checkNIE } = validationUtil;

    const getSpanishNameValidationConfig = (tooShortError, tooLongError, requiredError, firstNameRe = /^[A-Za-züõöÖÄß,\.\'\s\-]+$/) => {
        return {

            fn: {
                fn: function($inputs) {
                    var nameValue = $inputs[0].value || '';

                    if (nameValue && !firstNameRe.test(nameValue)) {
                        this.message = i18n.t('playtech.mobile.system.user.tooltip.firstname.regexp');
                        return false;
                    } else if (nameValue.length > 40) { /* Sportium changes - changed to 40 according to registration in CMS form */
                        this.message = i18n.t(tooLongError);
                        return false;
                    } else if (!nameValue) {
                        this.message = i18n.t(requiredError);
                        return false;
                    } else if (nameValue.length < 2) {
                        this.message = i18n.t(tooShortError);
                        return false;
                    }

                    return true;
                },
                message: i18n.t('playtech.mobile.system.tooltip.required')
            }
        };
    };

    return {
        checkControlLetter,
        checkDNI,
        checkNIE,
        getSpanishNameValidationConfig
    };
});
